export const Logo = ({ className = "h-9 w-9" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M4.5 7.5h2l1.4-2.2a1 1 0 0 1 .85-.47h6.5a1 1 0 0 1 .85.47l1.4 2.2h2a1.5 1.5 0 0 1 1.5 1.5v8.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5V9a1.5 1.5 0 0 1 1.5-1.5Z" />
    <circle cx="12" cy="12.6" r="3.6" />
    <path d="M10.1 9.6c-.9 1.2-.9 5 0 6.2" strokeDasharray="0.8 1.1" />
    <path d="M13.9 9.6c.9 1.2.9 5 0 6.2" strokeDasharray="0.8 1.1" />
  </svg>
);
